<template>
  <v-container fluid grid-list-md>
    <!-- <v-row>
      <v-col cols="12" justify-center> -->
        <v-container fluid style="padding: 0px;">
          <v-card>
            <v-toolbar elevation="0">
              <v-toolbar-title>Settings</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn class="mx-1" light color="success" @click="saveSiteSettings">Save</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-card-title>Menu Settings</v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="Worker Label"
                    v-model="settings.workerLabel"
                    :disabled="settings.hideWorkers">
                  </v-text-field>
                  <v-text-field
                    label="Item Label"
                    v-model="settings.itemLabel">
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-checkbox
                    label="Hide Workers"
                    v-model="settings.hideWorkers">
                  </v-checkbox>
                </v-col>
                <!-- <v-btn color="green" dark>Save</v-btn> -->
                <v-col cols="12">
                </v-col>
                <v-col cols="3">
                  <v-card-title>Field Settings</v-card-title>
                  <v-text-field
                    label="Item Name Label"
                    v-model="settings.itemNameLabel">
                  </v-text-field>
                  <v-text-field
                    label="Item Serial Label"
                    v-model="settings.itemSerialLabel">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-card-title>Lot Settings</v-card-title>
                    <v-combobox
                      v-model="fetchUICategories"
                      :items="getCategories"
                      item-value="id"
                      item-text="name"
                      label="Parent Categories"
                      @input="handleSettingsCategories"
                      chips
                      multiple
                      deletable-chips>
                    </v-combobox>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    append-icon
                    label="Show Label Header (Thing List)"
                    v-model="swapLotHeaders">
                  <v-icon>mdi-information</v-icon></v-checkbox>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    label="Flatten Events Export"
                    v-model="settings.flattenEventsExports">
                  ></v-checkbox>
                  <v-text-field
                    label="Tag Prefix"
                    v-model="settings.orgTagPrefix">
                  </v-text-field>
                  <v-checkbox
                    label="Prefixed Tag Duplicate Check"
                    v-model="settings.importSettings.prefixedTagDupCheck">
                  </v-checkbox>
                  <v-checkbox
                    label="Generate Prefix Tag"
                    v-model="settings.importSettings.generatePrefixTag">
                  </v-checkbox>
                  <v-checkbox
                    label="Require Zone on import"
                    v-model="settings.importSettings.requireZone">
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      <!-- </v-col>
    </v-row> -->
    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      tabs: ['UI Settings', 'Import Settings', 'Lot Settings'],
      errorText: '',
      settings: {},
      orgCategories: [],
      parentCategories: [],
      thingHeaders: [],
      swapLotHeaders: false,
      flattenEventsExport: false
    }
  },

  created () {
    // this.fetchUICategories()
  },

  mounted () {
    this.settings = JSON.parse(JSON.stringify(this.siteSettings))
    if (this.settings.parentCategories !== null) {
      this.parentCategories = this.settings.parentCategories
    } else {
      this.settings.parentCategories = this.parentCategories
    }
  },

  computed: {
    ...mapGetters([
      'siteSettings',
      'getCategories'
    ]),

    fetchUICategories: function () {
      let categories = []
      this.parentCategories.forEach(c => {
        this.getCategories.find(x => {
          if (x.id === c) {
            categories.push(x)
          }
        })
      })
      return categories
    }
  },

  watch: {
    settings: function () {
      this.enableLabelHeader()
    },

    swapLotHeaders: function () {
      if (this.swapLotHeaders) {
        this.settings.thingHeaders.push('label')
      } else {
        this.settings.thingHeaders = this.settings.thingHeaders.filter(x => x !== 'label')
      }
    }
  },

  methods: {
    ...mapActions([
      'getSiteSettings'
    ]),

    enableLabelHeader: function () {
      if (this.settings.thingHeaders.includes('label')) {
        this.swapLotHeaders = true
      } else {
        this.swapLotHeaders = false
      }
    },

    handleSettingsCategories: function (listItems) {
      this.settings.parentCategories = listItems.map(x => x.id)
    },

    saveSiteSettings: function () {
      ApiRequests.putSiteSettings(this.settings)
      .then(() => {
        this.getSiteSettings()
        this.errorText = 'Saved'
      })
      .catch(e => {
        this.errorText = 'Failed to save: ' + e.response.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SiteSettings.vue